import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Check, Copy } from 'lucide-react';
import { useState } from 'react';
export function CopyAmadeusButton({ disabled, disabledTitle, text }) {
    const [copied, setCopied] = useState(false);
    const handleCopy = async () => {
        if (disabled)
            return;
        await navigator.clipboard.writeText(text);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };
    return (_jsxs("button", { className: disabled
            ? 'inline-flex cursor-not-allowed items-center gap-1 rounded bg-gray-50 px-2 py-1 font-mono text-xs text-gray-400'
            : 'inline-flex items-center gap-1 rounded bg-gray-100 px-2 py-1 font-mono text-xs text-gray-700 transition-colors hover:bg-gray-200', disabled: disabled, onClick: handleCopy, title: disabled ? (disabledTitle ?? 'Copie indisponible') : 'Copier le format Amadeus', type: "button", children: [_jsx("span", { className: "max-w-[280px] truncate", children: text }), copied ? (_jsx(Check, { className: "h-3 w-3 shrink-0 text-green-600" })) : (_jsx(Copy, { className: "h-3 w-3 shrink-0 text-gray-400" }))] }));
}
